import { TanStackDevtools } from '@tanstack/react-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { MosaicDevtoolsPanel } from '@/devtools/MosaicDevtoolsPanel';
import { useBWTag } from '@/helpers/hooks';
import type { AppStore } from '@/store';

export interface RouterContext {
  store: AppStore;
}
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  validateSearch: (search: Record<string, unknown>): { tenant?: string } => {
    return {
      tenant: search.tenant as string,
    };
  },
});

function RootComponent() {
  useBWTag();
  const mode = import.meta.env.MODE;
  if (mode === 'development' || mode === 'preview') {
    const tenant = localStorage.getItem('tenant');
    if (tenant) {
      localStorage.setItem('tenant', tenant);
    }
  }

  return (
    <>
      <Outlet />
      <TanStackDevtools
        config={{
          position: 'bottom-right',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          {
            name: 'Mosaic',
            render: <MosaicDevtoolsPanel />,
          },
        ]}
      />
    </>
  );
}
